import { render, staticRenderFns } from "./ListaProdutos.vue?vue&type=template&id=45d7a3f0&scoped=true"
import script from "./ListaProdutos.vue?vue&type=script&lang=js"
export * from "./ListaProdutos.vue?vue&type=script&lang=js"
import style0 from "./ListaProdutos.vue?vue&type=style&index=0&id=45d7a3f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d7a3f0",
  null
  
)

export default component.exports